import { IResponse, IResponsePagination } from '@/types/common';
import {
  ICreateBannerRequest,
  IGetListBannerRequest,
  IUpdateBannerRequest,
} from '@/types/request';
import { IGetListBannerResponse } from '@/types/response';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class Banner {
  getList = (
    params: IGetListBannerRequest,
  ): Promise<IResponsePagination<IGetListBannerResponse>> => {
    return axiosClient.get(ENDPOINT.BANNER.GET_LIST, { params: params });
  };

  delete = (id: number) => {
    return axiosClient.delete(
      ENDPOINT.BANNER.DELETE.replace(':id', String(id)),
    );
  };

  create = (body: ICreateBannerRequest): Promise<IResponse<any>> => {
    return axiosClient.post(ENDPOINT.BANNER.CREATE, body);
  };

  getDetail = (id: number): Promise<IResponse<any>> => {
    return axiosClient.get(
      ENDPOINT.BANNER.GET_DETAIL.replace(':id', String(id)),
    );
  };

  update = (
    data: IUpdateBannerRequest,
    id: number,
  ): Promise<IResponse<any>> => {
    return axiosClient.put(
      ENDPOINT.BANNER.UPDATE.replace(':id', String(id)),
      data,
    );
  };
}

export const BannerService = new Banner();
